// extracted by mini-css-extract-plugin
module.exports = {"footerBtn":"filterFooter-module--footerBtn--1brna","secondaryBtn":"filterFooter-module--secondaryBtn--2Y84T"};